import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => (
  <div className="loading-screen" role="status" aria-label="Loading">
    <div className="loading-screen-content">
      <img
        src="/images/fav.png"
        alt="Byeilir"
        className="loading-screen-logo"
      />
      <div className="loading-screen-spinner" />
    </div>
  </div>
);

export default LoadingScreen;
